import React, {useState, useCallback} from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Autocomplete, AutocompleteItem,Icon, IconElement, Avatar, CheckBox  } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, View } from 'react-native';
import { useIsFocused } from "@react-navigation/native";
import { StatusBar } from 'expo-status-bar';
import Constants from "expo-constants"
import * as RootNavigation from '../../../../root.navigation.js';
import trackerApi from '../../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";

const width = Dimensions.get('window').width;

const movies = [
  { title: 'Star Wars' },
  { title: 'Back to the Future' },
  { title: 'The Matrix' },
  { title: 'Inception' },
  { title: 'Interstellar' },
];
const StarIcon = (props): IconElement => (
  <Icon
    {...props}
    name='star'
  />
);
const filter = (item, query): boolean => item.lastname.includes(query) || item.firstname.includes(query) || item.phone.includes(query);

export const AddSupervisorScreen = () => {
  const isVisible = useIsFocused();
  const [value, setValue] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [agents, setAgents] = React.useState([]);
  const [selectedAgent, setSelectedAgent] = React.useState({});
  const [checked, setChecked] = React.useState(false);
  // const getAgents = async(phone) =>{
  //   const token =  await AsyncStorage.getItem('userId');
  //   const response = await trackerApi.post('/app/searchagents', {phone}, {
  //     headers: {Authorization: `Bearer ${token}`}
  //   });
  //   if(response.data.status) {
  //     await setAgents(response.data.agent)
  //     console.log(response.data.agent[0])
  //     setData([{firstname: 'لطفا شماره مورد نظر را وارد کنید', lastname: '', phone:''}])
  //   }
  // }
  React.useEffect(()=>{
    console.log('test refreshing!');
    setData([{firstname: 'لطفا شماره مورد نظر را وارد کنید', lastname: '', phone:''}])

    // getAgents()
  }, [])

    const onSelect = useCallback((index): void => {
      setValue(data[index].firstname +' '+ data[index].lastname);
      setSelectedAgent(data[index])
    }, [data]);

    const onChangeText = async(query) => {
      setValue(query);
      if(query.length >10) {
        const token =  await AsyncStorage.getItem('userId');
        const response = await trackerApi.post('/app/searchagents', {phone: query}, {
          headers: {Authorization: `Bearer ${token}`}
        });
        console.log(response.data);
        if(response.data.status) {
          // await setAgents(response.data.agent)
          if(response.data.agent[0].phone) setData(response.data.agent)
          else setData([{firstname: 'چنین مشخصاتی یافت نشد', lastname: '', phone:''}])
        }        // console.log('searching: ', agents.filter(item => filter(item, query)));
        // if setData(agents.filter(item => filter(item, query)))
      }
      else setData([{firstname: 'لطفا شماره مورد نظر را وارد کنید', lastname: '', phone:''}])
    }
    const clearInput = (): void => {
      setValue('');
      setData([{firstname: 'لطفا شماره مورد نظر را وارد کنید', lastname: '', phone:''}])
      setSelectedAgent({})
    };
    const renderOption = (item, index): React.ReactElement => (
      <AutocompleteItem
        key={index}
        title={()=>{
          return(
            <View>
            <Text status='primary' style={{marginHorizontal:10}}>{item.firstname} {item.lastname}</Text>
            <Text appearance='hint' style={{marginHorizontal:10}}>{item.phone}</Text>
            </View>
          )
        }}
        accessoryLeft={()=>{
          return(
            <Avatar
              style={{width:64,height:64, marginVertical:10, borderWidth:3, borderColor:'#CEE8F9'}}
              source={{uri: `https://api.fntpf.ir/assets/uploaded/images/${item.img_uri}`}}
              />
          )
        }}
      />
    );
    const renderCloseIcon = (props): React.ReactElement => (
      <TouchableWithoutFeedback onPress={clearInput}>
        <Icon
          {...props}
          name='close'
        />
      </TouchableWithoutFeedback>
    );
    const addSubset = async() => {
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/app/add/subset', {subset: selectedAgent.phone, name: `${selectedAgent.firstname} ${selectedAgent.lastname}`}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) {
      showMessage({
          message: `با موفقیت افزوده شد.`,
          type: "success",
        });
      RootNavigation.navigate('profile')
      }
    else{
      showMessage({
          message: `خطای دسترسی به دیتابیس`,
          type: "danger",
        });
    }
  }
    return (
      <Layout style={styles.container}>
      <SafeAreaView>
      <View style={{alignItems:'center'}}>
        <Text status='primary' category='h5' style={{marginVertical:20, marginHorizontal:10}}>افزودن زیرمجموعه</Text>
        <Text category='c1' style={{marginVertical:10, marginHorizontal:10}}>اضافه کردن زیر مجموعه به منزله پذیرش تمامی قوانین و مقررات شرکت در این باره می‌باشد. لطفا قبل از ادامه فعالیت جهت اطلاع از قوانین با پشتیبانی شرکت تماس حاصل فرمایید.</Text>
        <Autocomplete
              placeholder='جستجوی تکنسین'
              value={value}
              style={{marginTop: 10, width: 0.85*width}}
              placement='inner top'
              accessoryRight={renderCloseIcon}
              onChangeText={onChangeText}
              onSelect={onSelect}
            >
              {data.map(renderOption)}
          </Autocomplete>
          { selectedAgent && selectedAgent.phone &&
            <View style={{width: width *0.9, marginTop:20}}>
            <Text status='primary' tyle={{marginHorizontal:10}}>اطلاعات تکنسین انتخاب شده:</Text>
            <Text style={{marginTop:20, marginHorizontal:10}}>نام: {selectedAgent.firstname} {selectedAgent.lastname}</Text>
            <Text style={{marginHorizontal:10}}>شماره تماس: {selectedAgent.phone}</Text>
            </View>
          }
            { selectedAgent && selectedAgent.phone &&
          <CheckBox
          style={{width: width *0.9, marginVertical:20}}
            checked={checked}
            onChange={nextChecked => setChecked(nextChecked)}
          >
            اینجانب متعهد میشوم که تمامی مسئولیت آقای {selectedAgent.firstname} {selectedAgent.lastname} با شماره تماس {selectedAgent.phone} و کدملی {selectedAgent.national_no} با بنده بوده و در صورت هرگونه مشکل پاسخگو خواهم بود.
          </CheckBox>
        }
          <View style={{flexDirection:'row', marginTop: 25}}>
          <Button onPress={()=>{RootNavigation.navigate('Supervisor')}} status='primary' appearance='outline' style={{borderRadius:5, marginHorizontal:5, flex: 1}}>بازگشت</Button>
          <Button disabled={!(checked && (selectedAgent && selectedAgent.phone))} onPress={addSubset} status='primary' style={{borderRadius:5, marginHorizontal:5, flex: 1}}>اضافه کردن</Button>
          </View>
        </View>
        <StatusBar backgroundColor='#134A93' style="light" />
        </SafeAreaView>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems: 'center'
  },
});
